
import { Options, Vue } from 'vue-class-component'
import * as THREE from 'three'
import { OrbitControls, MapControls } from "three/examples/jsm/controls/OrbitControls"
import { CSS3DRenderer, CSS3DSprite, CSS3DObject } from 'three/examples/jsm/renderers/CSS3DRenderer'
import { mapState, mapMutations } from 'vuex'

let camera, scene, renderer, controls, css3dRenderer, texture, videoTexture, imageTexture, videoMesh, imageMesh, pointGroup;
let $video;
let videos: any = ['',
  {
    type: 1,
    video: 'https://yunyingcdn.thecover.cn/o_1g6shl8i1t2lng197usu8m4fe.mp4',
    url: 'https://yunyingcdn.thecover.cn/o_1g6slrj1g1vrqj0613vkif3mcvj.mp4',
    camera: {
      x: 0.8,
      y: -0.1,
      z: -0.6
    },
    btn: 'https://yunyingcdn.thecover.cn/o_1gb24t9eu1ir52ch5569e71ite9.png',
    element: [
      {
        name: '小爪水獭',
        icon: 'https://yunyingcdn.thecover.cn/o_1gag7ila31k0k1e538ta15gf1cri9.png',
        position: {
          x: -374,
          y: -64,
          z: 324,
        },
        rotation: {
          y: -Math.PI / 4,
        },
        video: 'https://yunyingcdn.thecover.cn/o_1g6si7r0e17466jfm1onfu129u11.mp4',
        image: '',
        intro: '我是亚洲小爪水獭，国家二级保护动物，只在最优质的水系中生活，吊罗山是我在全国唯一的家。我喜欢白天睡觉，晚上抓螃蟹和小鱼当食物，你想和我一起生活在这里吗？',
      },
      {
        name: '蛇雕',
        icon: 'https://yunyingcdn.thecover.cn/o_1gb4nn8uk1krjanpbf512iga6s1k.png',
        position: {
          x: -295,
          y: 247,
          z: -317,
        },
        rotation: {
          y: Math.PI / 4,
        },
        scale: 0.2,
        video: 'https://yunyingcdn.thecover.cn/o_1g73ij5711pol4atc1lk0h11fqt.mp4',
        image: '',
        intro: '看到我酷酷的黑色羽冠了吗？我是拥有千里眼的高空王者蛇雕，国家二级保护动物，蛇最害怕的猎手，就算毒牙也咬不穿我的跗跖。',
        enter: true,
      },
      {
        name: '圆鼻巨蜥',
        icon: 'https://yunyingcdn.thecover.cn/o_1gb4nn8ukqdf2kd1jjc11c0ltc1r.png',  // ?
        scale: .6,
        position: {
          x: -403,
          y: -295,
          z: -8,
        },
        rotation: {
          y: -Math.PI / 2
        },
        video: '',
        image: 'https://yunyingcdn.thecover.cn/o_1g6pu2nbvui9noqchn7o5pako.jpg',
        intro: '我可不是一般的小蜥蜴，近2米的身长让我成为蜥蜴届的明星，吻部是圆圆的，所以叫圆鼻巨蜥，我是珍贵的国家一级保护动物',
      },
      {
        name: '猕猴',
        icon: 'https://yunyingcdn.thecover.cn/o_1gb4nn8uk15d7kpr127dhn313ur1g.png',
        position: {
          x: 359,
          y: 7,
          z: 345,
        },
        rotation: {
          y: Math.PI / 4,
        },
        scale: .4,
        video: 'https://yunyingcdn.thecover.cn/o_1g73ij5711bvi1qtv1panl701aanv.mp4',
        image: '',
        intro: '我可以帮你梳梳毛，这是我们交朋友的方式。虽然我在地面上行走，在树上睡觉，但其实我最喜欢在水里玩耍，是游泳健将。',
      },
      {
        name: '坡垒',
        icon: 'https://yunyingcdn.thecover.cn/o_1gb4nn8ukntb1fd31cpo124317l41h.png',  // ?
        position: {
          x: -450,
          y: 212,
          z: 24,
        },
        scale: .3,
        rotation: {
          y: -Math.PI / 2
        },
        video: 'https://yunyingcdn.thecover.cn/o_1g73ij5711auo33fgh317k065ku.mp4',
        image: '',
        intro: '我叫坡垒，身高20米，我给种子插上“翅膀”让它们飞去更远的地方播种，避免在我的脚下争夺营养，这就是国家一级保护植物的智慧',
      },
    ],
  },
  // 五指山
  {
    type: 1,
    video: 'https://yunyingcdn.thecover.cn/o_1g6sjus817iv1hn6nak17unpjr9.mp4',  // 过度视频
    url: '',  // 全景视频
    img: 'https://yunyingcdn.thecover.cn/o_1g6kr43m5tks4lg4e814ridp59.jpg',  // 全景图片
    camera: {
      x: 1,
      y: -0.1,
      z: -0.07
    },
    btn: 'https://yunyingcdn.thecover.cn/o_1gb2542323ce1th89po1g7s1i43m.png',
    element: [
      {
        name: '黎锦&黎歌',
        icon: 'https://yunyingcdn.thecover.cn/o_1gb4nn8uk1n59ap6stkdci19nb1j.png',
        position: {
          x: 31,
          y: -129,
          z: -481,
        },
        scale: 1.2,
        video: 'https://yunyingcdn.thecover.cn/o_1g73ij571jn1dimug71c7bkrk12.mp4',
        image: '',
        intro: '带上这个黎锦做的挂包吧，我们用自己染的鲜艳棉线，织出细密的提花，这份技艺是珍贵的非物质文化遗产。三月三带上它，一起来跳竹竿舞',
      },
      {
        name: '空中花园（鸟巢蕨）',
        icon: 'https://yunyingcdn.thecover.cn/o_1gb4nn8ul1p1119j08spus21osb2f.png',
        position: {
          x: 194,
          y: 329,
          z: -321,
        },
        scale: .5,
        video: 'https://yunyingcdn.thecover.cn/o_1g73ij571jdqskf1raa2hk13nl10.mp4',
        image: '',
        intro: '热带雨林的地上太挤啦，聪明的植物都会爬上大树，我是附生在树上的植物之一，收集落叶当养分，许多兰花也是花园里的邻居呢',
      },
      {
        name: '绞杀',
        icon: 'https://yunyingcdn.thecover.cn/o_1gb4nn8ul1td31iokbiakll1a1n2d.png',
        position: {
          x: -309,
          y: 224,
          z: 320,
        },
        rotation: {
          y: -Math.PI / 4,
        },
        video: '',
        image: 'https://yunyingcdn.thecover.cn/o_1g6p9om3rvjs14gg1lfu1emq1d1u17.jpg',
        intro: '我是榕树，为了在雨林里生存下去，会附生在棕榈树等大树身上，紧紧缠绕它们争夺养料和水分。等我长大后，根系深入地下，隔断附生大树的供给它们就会渐渐死去了，植物也有残酷的一面，你会害怕吗？',
      },
      {
        name: '丽拟丝蟌',
        icon: 'https://yunyingcdn.thecover.cn/o_1gb4nn8ukc6jd8t1hec1n501vcu1c.png',
        position: {
          x: 218,
          y: -172,
          z: 413,
        },
        rotation: {
          y: Math.PI / 4,
        },
        scale: .1,
        video: 'https://yunyingcdn.thecover.cn/o_1g73ij5711fg5110rq4l2s7e6111.mp4',
        image: '',
        intro: '小蜻蜓也会有绚丽的金黄色翅膀，它们叫我“凤凰”，不过我更喜欢自己的名字丽拟丝蟌。小小的我是国家二级保护动物，你只能在海南看到我。',
        enter: true,
        rotate: true,
      },
      {
        name: '小湍蛙',
        icon: 'https://yunyingcdn.thecover.cn/o_1gb4nn8uk1jlu7jf1e452b7i6f1p.png',
        position: {
          x: -475,
          y: -80,
          z: -130,
        },
        rotation: {
          y: -Math.PI / 2
        },
        scale: .15,
        video: 'https://yunyingcdn.thecover.cn/o_1g73ij5712jlske8seuoc1ruj13.mp4',
        image: '',
        intro: '我生活在湍急的溪流中，所以叫小湍蛙，我的趾蹼上有吸盘，不会被水流冲走。我的叫声很高亢，一般晚上才出来玩，只听蛙声，不见蛙身，很神秘吧？',
      },
    ]
  },
  // 黎母山
  {
    type: 1,
    video: 'https://yunyingcdn.thecover.cn/o_1g6sk16ti1bj9r991p0729m1kdie.mp4',  // 过度视频
    url: '',  // 全景视频
    img: 'https://yunyingcdn.thecover.cn/o_1g6nbi6vp16oc17p9e35161o1vi17.jpg',  // 全景图片
    camera: {
      x: 0.8,
      y: -0.1,
      z: -0.6
    },
    btn: 'https://yunyingcdn.thecover.cn/o_1gb2542321n6pj6pgn1ap41dhok.png',
    element: [
      {
        name: '海南巨松鼠',
        icon: 'https://yunyingcdn.thecover.cn/o_1gb4nn8ulcjccrl1j1m1vk83dn24.png',
        position: {
          x: -316,
          y: 218,
          z: -318,
        },
        rotation: {
          y: Math.PI / 4
        },
        scale: .15,
        video: '',
        image: 'https://yunyingcdn.thecover.cn/o_1g6pa160ute9k1ptevbch16kqt.jpg',
        intro: '不要被我的大尾巴吓到，我是海南巨松鼠。生活在树上的国家二级保护动物，我是雨林里的跳跃能手，要来比比吗？',
      },
      {
        name: '白鹇(银鸡)',
        icon: 'https://yunyingcdn.thecover.cn/o_1gb4nn8uk1d78n3ql87g3f14na1u.png',
        position: {
          x: -314,
          y: 28,
          z: 386,
        },
        rotation: {
          y: -Math.PI / 4
        },
        scale: .15,
        video: 'https://yunyingcdn.thecover.cn/o_1g73ij57166s5if1j9s1c61kmn14.mp4',
        image: '',
        intro: '我叫白鹇，脸红红的并不是害羞了，而是天生就这样，我的翎羽洁白华贵，自古以来就是名士贵族的宠儿，现在也是珍贵的国家二级保护动物。',
      },
      {
        name: '赤红山椒鸟',
        icon: 'https://yunyingcdn.thecover.cn/o_1gb4nn8ul1a8p1so41v8v13tc193g20.png',
        position: {
          x: 384,
          y: 280,
          z: 150,
        },
        rotation: {
          y: -Math.PI / 2
        },
        video: '',
        image: 'https://yunyingcdn.thecover.cn/o_1g6pa4euv1hvkq6cenr1pp1g6e12.jpg',
        intro: '火焰一样美丽的鸟儿，说的就是我，赤红山椒鸟，旁边的黄色鸟儿是我的妹妹，听我唱支歌吧',
      },
      {
        name: '海南苏铁',
        icon: 'https://yunyingcdn.thecover.cn/o_1gb4nn8uk1si0v12a40guv1s2m1n.png',
        position: {
          x: -475,
          y: -138,
          z: -63,
        },
        rotation: {
          y: -Math.PI / 2
        },
        video: '',
        image: 'https://yunyingcdn.thecover.cn/o_1g6pa6da61g1d2t19ou130qh2f9.jpg',
        intro: '我的叶子像鸟儿的尾羽，美丽却坚硬，两边有刺。我象征吉祥与长寿，也象征公正和无私。但其实我只是热爱阳光的国家一级保护植物——苏铁',
        enter: true,
        rotate: true,
      },
      {
        name: '石臼',
        icon: 'https://yunyingcdn.thecover.cn/o_1gb4nn8uk1ra613if7j519udqjc1l.png',
        position: {
          x: 213,
          y: -150,
          z: -425,
        },
        video: 'https://yunyingcdn.thecover.cn/o_1g73ij5711vut169ab1610f91na216.mp4',
        image: '',
        intro: '我可不是人类制造的石臼，像我这样坚硬的花岗岩河床，人类研究了许久也不能确定雕饰我的是冰川还是河流，你也是来找答案的吗？',
      },
    ],
  },
  // 鹦哥岭
  {
    type: 1,
    video: 'https://yunyingcdn.thecover.cn/o_1g6sk4jacp0a1r97a9e1fp64mc9.mp4',  // 过度视频
    url: '',  // 全景视频
    img: 'https://yunyingcdn.thecover.cn/o_1g6n5m30n60boc3ak2m2f685d.jpg',  // 全景图片
    camera: {
      x: 0.8,
      y: -0.1,
      z: -0.6
    },
    btn: 'https://yunyingcdn.thecover.cn/o_1gb2542323mg19o113ii8kp5irn.png',
    element: [
      {
        name: '金斑喙凤蝶',
        icon: 'https://yunyingcdn.thecover.cn/o_1gb4nn8ul36d9adeo0e7q16sm2e.png',
        position: {
          x: 205,
          y: 246,
          z: -382,
        },
        scale: .15,
        video: '',
        image: 'https://yunyingcdn.thecover.cn/o_1g6pa9eub9hsg6a2rt142c91he.jpg',
        intro: '所有蝴蝶中，我是唯一的国家一级保护动物，美丽的事物总是珍稀，我的翅展近90毫米，后翅有曼妙的“裙摆”镶嵌着金斑，是雨林里最耀眼的亮色。',
      },
      {
        name: '海南睑虎',
        icon: 'https://yunyingcdn.thecover.cn/o_1gb4nn8ulvaefqj1bhncrko4u2c.png',
        position: {
          x: -492,
          y: -44,
          z: 69,
        },
        rotation: {
          y: -Math.PI / 2
        },
        scale: .15,
        video: 'https://yunyingcdn.thecover.cn/o_1g73ij571nn9fsr8p06m14en19.mp4',
        image: '',
        intro: '我是会眨眼的壁虎科动物，眼睑保护着神秘的红色瞳孔，我叫海南睑虎，是国家二级保护动物，我的尾巴里储存着脂肪，肥肥的，遇到危险时会被我舍弃，可惜，新尾巴就没有漂亮的花纹了。',
        enter: true,
        rotate: true,
      },
      /* {
        name: '高大鹅膏',
        icon: '',
        position: {
          x: -333,
          y: -275,
          z: 249,
        },
        video: '',
        image: '',
        intro: '我是会“撑伞”的高大鹅膏，长大后能展开到手掌大小，雨林里许多真菌有毒，我是难得友好的可食用真菌，你可以在壳斗科植物林下找到我',
      }, */
      {
        name: '伯乐树',
        icon: 'https://yunyingcdn.thecover.cn/o_1gb4nn8uku1u4hl1uii18o214fq1v.png',
        position: {
          x: 284,
          y: 329,
          z: 245,
        },
        rotation: {
          y: Math.PI / 4,
        },
        video: '',
        image: 'https://yunyingcdn.thecover.cn/o_1g6pbbpni1s2a1d3714671i9u1smp9.jpg',
        intro: '伯乐树不常有，我是中国特有的第三纪孑遗植物，国家二级保护植物，因为结实稀少处于濒危状态，请多来看看我吧，花和果都这样美丽的树不多啦',
      },
    ],
  },
  // 毛瑞
  {
    type: 1,
    video: 'https://yunyingcdn.thecover.cn/o_1g6sk6l9esgg1imo41b104f3r9e.mp4',  // 过度视频
    url: '',  // 全景视频
    img: 'https://yunyingcdn.thecover.cn/o_1g6nbk20usqt1o921an21uadd719.jpg',  // 全景图片
    camera: {
      x: 0.8,
      y: -0.1,
      z: -0.6
    },
    btn: 'https://yunyingcdn.thecover.cn/o_1gb25423216i51drn1v3b1t1v1c71l.png',
    element: [
      {
        name: '仙安石林',
        icon: 'https://yunyingcdn.thecover.cn/o_1gb4nn8ukt2h1h3pgd910m61qdl1m.png',
        position: {
          x: -206,
          y: 153,
          z: -427,
        },
        video: 'https://yunyingcdn.thecover.cn/o_1g73ij571k021cba1pqun871b801a.mp4',
        image: '',
        intro: '不要攀爬，尖锐的石峰会让你没有落脚之地。距离产生美。我是世界上仅有的两处热带雨林喀斯特剑状针状石林之一，仙安石林。从高处俯视就能大饱眼福啦',
      },
      {
        name: '桫椤',
        icon: 'https://yunyingcdn.thecover.cn/o_1gb4nn8uk1ah4v3q1udq1f206vt1o.png',
        position: {
          x: 395,
          y: 208,
          z: 222,
        },
        rotation: {
          y: -Math.PI / 2,
        },
        video: 'https://yunyingcdn.thecover.cn/o_1g73ij5711jho12im1cg51fpl1e8315.mp4',
        image: '',
        intro: '咳咳咳，我是曾和恐龙相伴的植物活化石桫椤，唯一的木本蕨类植物，比我高的树没有蕨类叶子漂亮，比我漂亮的蕨类没有我高大的树形，我是最独一无二的国家二级保护植物。',
        enter: true,
      },
      {
        name: '青梅（二级）',
        icon: 'https://yunyingcdn.thecover.cn/o_1gb4nn8ukp7mrrj1kte17pe1gcj1i.png',
        position: {
          x: 161,
          y: 42,
          z: 470,
        },
        video: 'https://yunyingcdn.thecover.cn/o_1g73ij5711jfg272h105h5rf01c.mp4',
        image: '',
        intro: '我是没有竹马的青梅，也是不能吃的青梅，准确的说我是国家二级保护植物龙脑香科青梅属乔木，是身高20米的巨树，又开着纤细芳香的小花，这就是反差魅力',
      },
      {
        name: '海南紫荆木',
        icon: 'https://yunyingcdn.thecover.cn/o_1gb4nn8ulakehm4mec3cm19m328.png',
        position: {
          x: -443,
          y: 73,
          z: 216,
        },
        rotation: {
          y: -Math.PI / 4,
        },
        video: 'https://yunyingcdn.thecover.cn/o_1g73ij571pdk19eq1m6rns1fdf17.mp4',
        image: '',
        intro: '生在海拔1000米处的地方，身高峰值30米，比青梅厉害多了，我是只生活在海南的国家二级保护植物海南紫荆木。',
      },
      {
        name: '领鸺鹠',
        icon: 'https://yunyingcdn.thecover.cn/o_1gb4nn8uk1kan161lj9u4us1tbf1d.png',
        position: {
          x: 380,
          y: 235,
          z: -222,
        },
        rotation: {
          y: -Math.PI / 2
        },
        video: '',
        image: 'https://yunyingcdn.thecover.cn/o_1g6pbelhn1fb01hbg1um0a9919e3e.jpg',
        intro: '别被我背面的“假脸”骗了，那只是两块圆斑，为了吓唬我的天敌做一只“双面鸺鹠”，我也是国家二级保护动物哦',
      },
    ],
  },
  // 尖峰岭
  {
    type: 1,
    video: 'https://yunyingcdn.thecover.cn/o_1g6sk8ikg16sk1hi01ubj1mtb1bogo.mp4',  // 过度视频
    url: '',  // 全景视频
    img: 'https://yunyingcdn.thecover.cn/o_1g6nbko6j18a5149rech2f81umee.jpg',  // 全景图片
    camera: {
      x: 0.8,
      y: -0.1,
      z: -0.6
    },
    btn: 'https://yunyingcdn.thecover.cn/o_1gb25423216eddo86e1r582bpj.png',
    element: [
      {
        name: '海南粗榧',
        icon: 'https://yunyingcdn.thecover.cn/o_1gb4nn8ul18jr1qh11tqvhdtlpk23.png',
        position: {
          x: 381,
          y: 54,
          z: 316,
        },
        rotation: {
          y: Math.PI / 4,
        },
        video: '',
        image: 'https://yunyingcdn.thecover.cn/o_1g6pbh9mu8t0jb017g8pu616nsj.jpg',
        intro: '别人的是叶片，我的是叶条，圆鼓鼓的长条状树叶是不是也很可爱呢？我是国家二级保护植物海南粗榧，可以入药治疗白血病及淋巴肉瘤。',
      },
      {
        name: '黄腹花蜜鸟',
        icon: 'https://yunyingcdn.thecover.cn/o_1gb4nn8ul1iscqoc1akjd8j160p29.png',
        position: {
          x: -242,
          y: 89,
          z: -427,
        },
        rotation: {
          y: Math.PI / 4,
        },
        video: 'https://yunyingcdn.thecover.cn/o_1g73ij571p3g1f269mt9nomfv18.mp4',
        image: '',
        intro: '“唧唧喳喳”我是小小的黄腹花蜜鸟，明黄色的腹部和闪耀金属光泽的胸带都是我可爱的证据，吵闹活泼的小鸟就是我',
      },
      {
        name: '海南孔雀雉',
        icon: 'https://yunyingcdn.thecover.cn/o_1gb4nn8ul897kbk10ti5q3ng625.png',
        position: {
          x: -229,
          y: -311,
          z: -315,
        },
        scale: 0.5,
        video: 'https://yunyingcdn.thecover.cn/o_1g73ij57112tth01e33oc41d0c1b.mp4',
        image: '',
        intro: '被我美丽的尾羽吸引了吧，和孔雀的尾羽一样有着金属光泽的眼状斑，但我是国家一级保护动物海南孔雀雉。还是雉鸡中少有的“肉食者”，只吃昆虫，蠕虫。',
      },
      {
        name: '海南山鹧鸪',
        icon: 'https://yunyingcdn.thecover.cn/o_1gb4nn8ul1sn2o2tspp1darlfu27.png',
        position: {
          x: 474,
          y: -154,
          z: -24,
        },
        rotation: {
          y: -Math.PI / 2
        },
        scale: 0.5,
        video: 'https://yunyingcdn.thecover.cn/o_1g73ij571tta179hirua65v41d.mp4',
        image: '',
        intro: '我的脖子有一片橙红色羽毛，格外美丽，海南山鹧鸪就是我的名字，你喜欢我们家族的合唱吗？我们都是国家一级保护动物。',
        enter: true,
      },
      {
        name: '穿山甲',
        icon: 'https://yunyingcdn.thecover.cn/o_1gb4nn8ulol6hv1hlaree16pl21.png',
        position: {
          x: -481,
          y: 78,
          z: 107,
        },
        rotation: {
          y: -Math.PI / 2
        },
        scale: .15,
        video: '',
        image: 'https://yunyingcdn.thecover.cn/o_1g6pbkeik1urc4t2jus1n1o11ato.jpg',
        intro: '看，这是我刚挖的洞，有4米深，都是我这双爪子的功劳。我还有长长的舌头，舔到的白蚁都是我的食物。成为了国家一级保护动物后日子好过了许多，没有人抓我制作药物了。',
      },
    ]
  },
  // 霸王岭
  {
    type: 1,
    video: 'https://yunyingcdn.thecover.cn/o_1g6skc63t1dhqini1f8v1ed9kout.mp4',  // 过度视频
    url: 'https://yunyingcdn.thecover.cn/o_1g6smdkteaqc5t419rhcim13m39.mp4',  // 全景视频
    img: '',  // 全景图片
    camera: {
      x: 0.35,
      y: -0.1,
      z: 0.9
    },
    btn: 'https://yunyingcdn.thecover.cn/o_1gb254232ui196no3u732po8o.png',
    element: [
      {
        name: '海南坡鹿',
        icon: 'https://yunyingcdn.thecover.cn/o_1gb4nn8ul1fnj1i3nplo122hgfb26.png',
        position: {
          x: 484,
          y: -38,
          z: 116,
        },
        scale: .2,
        rotation: {
          y: -Math.PI / 2
        },
        video: 'https://yunyingcdn.thecover.cn/o_1g73ij57117aq1rq21bdh9la18he1e.mp4',
        image: '',
        intro: '我已经长大了，不是小梅花鹿，而是国家一级保护动物海南坡鹿，我们天生比梅花鹿体形更小，花斑也不同。很多人以为我会飞，其实我只是跳的比较远啦',
      },
      {
        name: '美花兰',
        icon: 'https://yunyingcdn.thecover.cn/o_1gb4nn8uk7m1i4jc9j1fjg28p1f.png',
        position: {
          x: -8,
          y: 200,
          z: -457,
        },
        video: 'https://yunyingcdn.thecover.cn/o_1g73ij571g87eln352skd10s91f.mp4',
        image: '',
        intro: '因为能开出美丽的花，我被叫做美花兰，是国家一级保护植物。我并不喜欢炫耀自己的美丽，只生活在幽静潮湿，没有阳光照射的地方。',
      },
      {
        name: '陆均松',
        icon: 'https://yunyingcdn.thecover.cn/o_1gb4nn8uk1mfd1t821sos1bg7l3c1e.png',
        position: {
          x: 391,
          y: 76,
          z: -300,
        },
        rotation: {
          y: -Math.PI / 4,
        },
        video: 'https://yunyingcdn.thecover.cn/o_1g73ij5711c3c1cfjm2v1iu92i71g.mp4',
        image: '',
        intro: '名字里有松，其实我是常绿乔木，喜欢光照充足的湿润环境，作为濒危植物在热带雨林国家公园安了家，再没有人来伤害我了。',
      },
      {
        name: '海南长臂猿',
        icon: 'https://yunyingcdn.thecover.cn/o_1gb4nn8ukvff14oh1fk44m917241s.png',
        position: {
          x: -409,
          y: 284,
          z: -35,
        },
        scale: .15,
        rotation: {
          y: -Math.PI / 2
        },
        video: 'https://yunyingcdn.thecover.cn/o_1g73ij571d0g6up1cah1bsgeh51h.mp4',
        image: '',
        intro: '你好，远道而来的朋友，我是全世界仅存的5群36只海南长臂猿之一，这是我的宝宝，刚刚半岁的婴猿。生活在最原始的热带雨林里，这里的花、藤、果、树，吵嚷的鸟儿、昆虫，奔跑跳跃的坡鹿、青蛙，都是我重要的朋友，我们很少交流，却联系着彼此的生命，少了谁都无法存活，只有大家都不受到伤害，我们才有可能继续繁衍。来到雨林就会成为我们共同的朋友，一起拍照留念吧',
        camera: true,
      },
    ]
  },
];

@Options({
  data() {
    return {
      isRi: true,  // 是否旋转画面
      isInfi: false,  // 是否循环播放动画
      video: {},  // type  0-普通视频；1-全景视频
      pop: {},
    }
  },
  computed: {
    ...mapState(['step', 'page'])
  },
  watch: {
    step() {
      this.handleStep();
    },
  },
  mounted() {
    $video = document.getElementById('video');
    this.handleStart();

    this.isInfi = true;

    const step = this.step;
    this.render();
    this.pointRender();
    this.video = {
      type: 1,
      url: videos[step].url,
      loop: true,
      btn: videos[step].btn,
    }

    const c = videos[step].camera;
    camera.position.set(c.x, c.y, c.z);

    if (videos[step].img) {
      videoMesh.visible = false;
      this.imgRender(videos[step].img);
      return;
    }
    scene.remove(imageMesh);
    texture = videoTexture;
    videoMesh.visible = true;
    this.$nextTick(() => {
      $video.play();
    });
  },
  methods: {
    ...mapMutations(['SET_PAGE', 'SET_STEP']),
    handleStep() {
      const step = this.step;
      if (step === 1) {
        this.isShowMap = true;
        this.video = {};
        return;
      }

      this.pointRender();
      this.video = {
        type: 1,
        url: videos[step].url,
        loop: true,
        btn: videos[step].btn,
      }

      const c = videos[step].camera;
      camera.position.set(c.x, c.y, c.z);
      // camera.setFocalLength(15);

      if (videos[step].img) {
        videoMesh.visible = false;
        this.imgRender(videos[step].img);
        return;
      }
      scene.remove(imageMesh);
      this.$nextTick(() => {
        $video.play();
        this.videoRender();
      });
    },
    handleStart() {
      this.video = {
        type: 0,
        url: 'https://yunyingcdn.thecover.cn/o_1g6sfuocr1p50rl7bh8avnatv9.mp4',
        loop: false,
      }
      this.$nextTick(() => {
        $video.play();
      });
      /* this.renderParam = 1;
      this.$nextTick(() => {
        this.render();
      }); */
    },
    render() {
      const _this = this;
			init();
			animate();

			function init() {
				const container: any = document.getElementById( 'container' );
        let containerWidth = window.innerWidth;
        let containerHeight = window.innerHeight;
        scene = new THREE.Scene();

        /* if (_this.isRi) {
          containerWidth = window.innerHeight;
          containerHeight = window.innerWidth;
        } */

				camera = new THREE.PerspectiveCamera( 75, containerWidth / containerHeight, 1, 1100 );
        camera.position.set( 0, 0, 1 );
        /* camera.rotation.x = -Math.PI / 2;
        camera.rotation.y = -Math.PI / 2;
        camera.rotation.z = Math.PI / 2; */
				// scene.add(camera);

        /* if (_this.isRi) {
          scene.rotation.x = -Math.PI / 2;
        } */

				_this.videoRender();

				renderer = new THREE.WebGLRenderer();
				renderer.setPixelRatio( window.devicePixelRatio );
				renderer.setSize( containerWidth, containerHeight );
				container.appendChild( renderer.domElement );

        css3dRenderer = new CSS3DRenderer();
        css3dRenderer.setSize(containerWidth, containerHeight);
        css3dRenderer.domElement.style.position = 'absolute';
        css3dRenderer.domElement.style.left = 0;
        css3dRenderer.domElement.style.top = 0;
        container.appendChild( css3dRenderer.domElement );

        controls = new OrbitControls(camera, css3dRenderer.domElement);
        controls.listenToKeyEvents( window );
        controls.autoRotate = true;
        controls.autoRotateSpeed = 0.1;

        // controls.enableZoom = true;
        // controls.zoomSpeed = 1;
        // controls.enableRotate = false;
        /* controls.enableZoom = false;
        controls.enablePan = false;
        controls.enableDamping = true;
        controls.dampingFactor = 0.15;
        controls.rotateSpeed = -0.1; */

				//
				window.addEventListener( 'resize', onWindowResize );
        container.addEventListener('click', (event) => {
          console.log(event);
          console.log(camera);
          console.log(controls);
          event.preventDefault();
          let raycaster = new THREE.Raycaster();
          let mouse = new THREE.Vector2();

          mouse.x = (event.clientX / containerWidth) * 2 - 1;
          mouse.y = -(event.clientY / containerHeight) * 2 + 1;
          // 触摸手势取第一个
          if (event.changedTouches && event.changedTouches.length) {
            const touch = event.changedTouches[0];
            mouse.x = (touch.clientX / containerWidth) * 2 - 1;
            mouse.y = -(touch.clientY / containerHeight) * 2 + 1;
          }

          raycaster.setFromCamera(mouse, camera);
          const intersects = raycaster.intersectObject(videoMesh, true);
          console.log(intersects);
        });

        function onWindowResize() {
          camera.aspect = containerWidth / containerHeight;
          camera.updateProjectionMatrix();
          renderer.setSize( containerWidth, containerHeight );
        }
			}

			function animate() {
				requestAnimationFrame( animate );
				controls.update();
        renderer.render( scene, camera );
        css3dRenderer.render(scene, camera);
			}

      const element = document.createElement('div');
      element.innerHTML = `<img src='https://yunyingcdn.thecover.cn/o_1g6ncpj1crkbj4pgj91vadl93j.png' />`;
      const object = new CSS3DObject(element);
      object.position.set(0, -500, 40);
      object.scale.multiplyScalar(.8);
      object.rotation.x = Math.PI / 2;
      scene.add(object);
    },
    videoRender() {
      const geometry = new THREE.SphereGeometry( 500, 60, 40 );
      geometry.scale(-1, 1, 1);

      $video.play();

      videoTexture = new THREE.VideoTexture($video);
      videoTexture.generateMipmaps = false;
      videoTexture.minFilter = THREE.LinearFilter;
      videoTexture.magFilter = THREE.LinearFilter;
      videoTexture.format = THREE.RGBAFormat;

      texture = videoTexture;
      const material = new THREE.MeshBasicMaterial({ map: texture });
      videoMesh = new THREE.Mesh( geometry, material );
      scene.add(videoMesh);
    },
    imgRender(path) {
      const geometry = new THREE.SphereGeometry( 500, 60, 40 );
      geometry.scale(-1, 1, 1);

      imageTexture = new THREE.TextureLoader().load( path );;
      const material = new THREE.MeshBasicMaterial({ map: imageTexture });
      imageMesh = new THREE.Mesh( geometry, material );
      scene.add(imageMesh);
    },
    pointRender() {
      const step = this.step;
      const ele = videos[step].element;
      if (pointGroup) {
        pointGroup.clear();
        scene.remove(pointGroup);
        renderer.render( scene, camera );
        css3dRenderer.render(scene, camera);
      }

      pointGroup = new THREE.Group();

      for (let i = 0; i < ele.length; i++) {
        const element = document.createElement('div');
        let next = '';
        if (ele[i].enter) {
          next = `<img class="next ${ ele[i].rotate ? 'rotate' : '' }" src='https://yunyingcdn.thecover.cn/o_1gag8mmqr1mjb4cl198cgbo1j6te.png' />`
        }
        element.innerHTML = `<div class="ele-icon"><img src='${ele[i].icon}?imageView2/2/w/200' class="point-img" />${ next }</div>`;
        element.addEventListener('click', () => {
          /* this.video = {
            type: 0,
            url: videos[step].video,
            loop: false,
          }
          this.$nextTick(() => {
            $video.play();
          }); */
          this.pop = {
            name: ele[i].name,
            video: ele[i].video,
            image: ele[i].image,
            content: ele[i].intro,
            enter: ele[i].enter,
            camera: ele[i].camera,
          }
        });
        const object = new CSS3DObject(element);
        const position = ele[i].position;
        const rotation = ele[i].rotation || {};
        object.position.set(position.x, position.y, position.z);
        object.scale.multiplyScalar(0.3);
        object.rotation.x = rotation.x || 0;
        object.rotation.y = rotation.y || 0;
        object.rotation.z = rotation.z || 0;
        pointGroup.add(object);
      }

      scene.add(pointGroup);
    },
    handleIntro() {
      const info = videos[this.step];
      this.pop = {
        video: info.video,
      }
    },
    handleNext() {
      this.pop = {};
      this.SET_PAGE(2);
      this.SET_STEP(++this.step);
    },
    handleCamera() {
      this.pop = {};
      this.SET_PAGE(3);
    },
  }
})
export default class Map extends Vue {}
